import React from "react";
import { Helmet } from "react-helmet";
import AboutBody from "../components/about/AboutBody";
import Clientelle from "../components/home/Clientelle";
import OurWorks from "../components/home/OurWork";
import PageHero from "../components/reusables/hero/PageHero";

export default function About() {
  return (
    <>
      <Helmet>
        <link
          rel="conanical"
          href="https://www.negash.co/about-us"
        />
        <meta
          name="description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta
          property="og:description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta property="og:title" content="About Us - Negash Construction Company" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1708492028/jmstonebanner_hoycxz.jpg"
        />

        <meta name="twitter:title" content="About Us - Negash Construction Company" />
        <meta
          name="twitter:text:title"
          content="About Us - Negash Construction Company"
        />
        <meta
          name="twitter:description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1708492028/jmstonebanner_hoycxz.jpg"
        />
        <title>About Us - Negash Construction Company</title>
      </Helmet>
      <PageHero
        classes="doggy-bg"
        titleClasses="title uppercase white text-shadow"
        title="About US"
      />
      <AboutBody />
      <OurWorks />
      <Clientelle />
    </>
  );
}
